'use strict'

var separate = require('./separate')

module.exports = function(name){
   return separate(name).toLowerCase()
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/stringUtils/hyphenate.js
// module id = 366
// module chunks = 0